<script lang="ts" setup>
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { AuctionCar, BarometerCar, DetailsCarItemData } from '@autobid/ui/types/Car'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useSpecialConditionNotification } from '@autobid/ui/composables/auction/useSpecialConditionNotification'

interface Props {
  scaPopupSlug?: string
  car: AuctionCar | BarometerCar | DetailsCarItemData | PreviewItemData
  size: 'small' | 'big'
}

const props = defineProps<Props>()
const { isAuthed } = useAutobidAuth()

const { doesAuctionMeetConditions } = useSpecialConditionNotification({
  auctionId: props.car.auctionId,
})
</script>

<template>
  <template v-if="isAuthed">
    <DynamicAuctionItemListCarActionsBidded
      v-if="car.hasBid"
      :size="size"
      v-bind="$attrs"
    />

    <DynamicAuctionItemListCarActionsSca
      v-if="car.status.bmwBankFinancingAvailable && scaPopupSlug"
      :slug="scaPopupSlug"
      :size="size"
      v-bind="$attrs"
    />
    <DevOnly v-else-if="!scaPopupSlug">
      <CommonTooltip tooltip="scaPopupSlug not provided">
        <DynamicAuctionItemListCarIcon
          variant="orange"
          size="small"
          v-bind="$attrs"
        >
          <span class="text-xs">Error</span>
        </DynamicAuctionItemListCarIcon>
      </CommonTooltip>
    </DevOnly>

    <DynamicAuctionItemListCarActionsBank11
      v-if="car.status.bank11FinancingAvailable"
      v-bind="$attrs"
      :size="size"
    />

    <DynamicAuctionItemListCarActionsSpecialConditionInfo
      v-if="doesAuctionMeetConditions"
      v-bind="$attrs"
      :size="size"
      :auction-id="car.auctionId"
    />
  </template>
</template>
